/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */

import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import MapScraper from '../components/mapScraper';

function ProductMapScraper() {
  return (
    <div className="main">
      <Header />
      <MapScraper />
      <Footer />
    </div>
  );
}

export default ProductMapScraper;
